import BaseAutocomplete from '@components/common/atoms/BaseAutocomplete';
import { useRootStore } from '@hooks/useRootStore';
import LocationOnTwoToneIcon from '@mui/icons-material/LocationOnTwoTone';
import { Box, Paper, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React from 'react';
import CityDropdown from './CityDropdown';

interface RestaurantCitySelectorProps {
}

const RestaurantCitySelector: React.FC<RestaurantCitySelectorProps> = observer(({ }) => {
    const { cityStore } = useRootStore();
    const { findAsync, cities, selectedCity, onCityChange } = cityStore;
    return (
        <Paper
            elevation={0}
            sx={{
                p: { xs: 4, md: 6 },
                pl: { xs: 2, md: 8 },
                pr: { xs: 2, md: 8 },
                width: "100%",
                backgroundColor: "transparent"
            }} >
            <Box
                display={"flex"}
                flexDirection={"column"}
                alignItems={"center"}
            >
                <LocationOnTwoToneIcon color='primary' sx={{ fontSize: 58, }} />
                <Typography
                    fontWeight={600}
                    color={"#fff"}
                    variant='h5'
                    mt={1}
                    mb={4}>
                    Odaberi grad, restoran, pronađi jelo i naruči!
                </Typography>
                <CityDropdown cities={cities} selectedCity={selectedCity} findCitiesFn={findAsync} onCityChange={onCityChange} />

                {/* <BaseAutocomplete
                    title='Grad'
                    icon={<LocationOnTwoToneIcon color='action' />}
                    findFunction={findAsync}
                    options={cities}
                    value={selectedCity}
                    onChange={onCityChange} /> */}
            </Box>
        </Paper>
    )
})

export default RestaurantCitySelector;